module.exports = __webpack_public_path__ + "static/media/underfloor-heating.996ec343.jpg";